var canvas, zoom, cWidth = 1400, cHeight = 2000,
    halfWidth = cWidth / 2, halfHeight = cHeight / 2,
    obj, sizeCrop, input, img;

var loader = jQuery('#customLoader'),
    cropper = "", aspectRatio, reCroper;

var sizeB1W = 288, sizeB1H = 277;

imageUrl = document.getElementById('imageContainer').getAttribute('data-image-url');



let backImg = document.querySelector("#background_image");
let backgroundImage = new fabric.Image(backImg, {
  left: 0,
  top: 0,
  scaleX: 2,
  scaleY: 2,
  selectable: false
});


window['canvas'] = new fabric.Canvas('canvas2',{
  width:cWidth,
  height:cHeight
});

window['canvas'].add(backgroundImage);
addModify(window['canvas']);

window['placeholderimg1'] = new fabric.Rect({
  left: 194,
  top: 188.5,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)'
});

const placeholderText1 = new fabric.Text('1', {
  left:194,
  top: 188.5,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText1);

window['placeholderimg2'] = new fabric.Rect({
  left: 531,
  top: 188.5,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)'
});

const placeholderText2 = new fabric.Text('2', {
  left:531,
  top: 188.5,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText2);

window['placeholderimg3'] = new fabric.Rect({
  left: 870,
  top: 188.5,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText3 = new fabric.Text('3', {
  left:870,
  top: 188.5,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText3);

window['placeholderimg4'] = new fabric.Rect({
  left: 1209,
  top: 188.5,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText4 = new fabric.Text('4', {
  left:1209,
  top: 188.5,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText4);

window['placeholderimg5'] = new fabric.Rect({
  left: 194,
  top: 513.5,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText5 = new fabric.Text('5', {
  left:194,
  top: 513.5,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText5);

window['placeholderimg6'] = new fabric.Rect({
  left: 531,
  top: 513.5,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText6 = new fabric.Text('6', {
  left:531,
  top: 513.5,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText6);

window['placeholderimg7'] = new fabric.Rect({
  left: 870,
  top: 513.5,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText7 = new fabric.Text('7', {
  left:870,
  top: 513.5,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText7);

window['placeholderimg8'] = new fabric.Rect({
  left: 1209,
  top: 513.5,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText8 = new fabric.Text('8', {
  left:1209,
  top: 513.5,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText8);

window['placeholderimg9'] = new fabric.Rect({
  left: 194,
  top: 839.5,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText9 = new fabric.Text('9', {
  left:194,
  top: 839.5,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText9);

window['placeholderimg10'] = new fabric.Rect({
  left: 531,
  top: 839.5,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText10 = new fabric.Text('10', {
  left:531,
  top: 839.5,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText10);

window['placeholderimg11'] = new fabric.Rect({
  left: 870,
  top: 839.5,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText11 = new fabric.Text('11', {
  left:870,
  top: 839.5,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText11);

window['placeholderimg12'] = new fabric.Rect({
  left: 1209,
  top: 839.5,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText12 = new fabric.Text('12', {
  left:1209,
  top: 839.5,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText12);

window['placeholderimg13'] = new fabric.Rect({
  left: 194,
  top: 1162.5,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText13 = new fabric.Text('13', {
  left:194,
  top: 1162.5,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText13);

window['placeholderimg14'] = new fabric.Rect({
  left: 531,
  top: 1162.5,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText14 = new fabric.Text('14', {
  left:531,
  top: 1162.5,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText14);

window['placeholderimg15'] = new fabric.Rect({
  left: 870,
  top: 1162.5,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText15 = new fabric.Text('15', {
  left:870,
  top: 1162.5,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText15);

window['placeholderimg16'] = new fabric.Rect({
  left: 1209,
  top: 1162.5,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText16 = new fabric.Text('16', {
  left:1209,
  top: 1162.5,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText16);

window['placeholderimg17'] = new fabric.Rect({
  left: 194,
  top: 1487.5,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText17 = new fabric.Text('17', {
  left:194,
  top: 1487.5,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText17);

window['placeholderimg18'] = new fabric.Rect({
  left: 531,
  top: 1487.5,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText18 = new fabric.Text('18', {
  left:531,
  top: 1487.5,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText18);

window['placeholderimg19'] = new fabric.Rect({
  left: 870,
  top: 1487.5,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText19 = new fabric.Text('19', {
  left:870,
  top: 1487.5,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText19);

window['placeholderimg20'] = new fabric.Rect({
  left: 1209,
  top: 1487.5,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText20 = new fabric.Text('20', {
  left:1209,
  top: 1487.5,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText20);

window['placeholderimg21'] = new fabric.Rect({
  left: 194,
  top: 1812.5,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText21 = new fabric.Text('21', {
  left:194,
  top: 1812.5,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText21);

window['placeholderimg22'] = new fabric.Rect({
  left: 531,
  top: 1812.5,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText22 = new fabric.Text('22', {
  left:531,
  top: 1812.5,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText22);

window['placeholderimg23'] = new fabric.Rect({
  left: 870,
  top: 1812.5,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText23 = new fabric.Text('23', {
  left:870,
  top: 1812.5,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText23);

window['placeholderimg24'] = new fabric.Rect({
  left: 1209,
  top: 1812.5,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText24 = new fabric.Text('24', {
  left:1209,
  top: 1812.5,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText24);


window['canvas'].add(window['placeholderimg1'], window['placeholderimg2'], window['placeholderimg3'], window['placeholderimg4'], window['placeholderimg5'], window['placeholderimg6'],
                      window['placeholderimg7'], window['placeholderimg8'], window['placeholderimg9'], window['placeholderimg10'], window['placeholderimg11'], window['placeholderimg12'],
                      window['placeholderimg13'], window['placeholderimg14'], window['placeholderimg15'], window['placeholderimg16'], window['placeholderimg17'], window['placeholderimg18'],
                      window['placeholderimg19'], window['placeholderimg20'], window['placeholderimg21'], window['placeholderimg22'], window['placeholderimg23'], window['placeholderimg24']);

document.getElementById('image_upload_first').addEventListener('change',function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg1'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_second').addEventListener('change',function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg2'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_third').addEventListener('change',function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg3'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_fourth').addEventListener('change',function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg4'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_fifth').addEventListener('change',function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg5'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_sixth').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg6'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_seventh').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg7'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_eight').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg8'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});


document.getElementById('image_upload_ninth').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg9'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_tenth').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg10'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_eleventh').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg11'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_twelfth').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg12'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_thirteenth').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg13'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_fourteenth').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg14'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_fifteen').addEventListener('change',function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg15'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_sixteen').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg16'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_seventeen').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg17'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_eighteen').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg18'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});


document.getElementById('image_upload_ninteen').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg19'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_twenty').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg20'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_twentyone').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg21'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_twentytwo').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg22'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_twentythree').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg23'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_twentyfour').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg24'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

function addModify(canvas){
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;

  canvas.renderOnAddRemove = false;

  canvas.on('object:added', function(e){
    object = e.target;
    object.set({
      selectable:false,
      originX:"center",
      originY:"center",
    });
    canvas.renderAll();
  });
}